<div class="transaction-property-detail">
    <app-child-breadcum [property_uid]="propertyInfo?.property_uid" (back)="backToTransaction()"></app-child-breadcum>

    <ng-container *ngIf="allDataLoading">
        <app-skeleton-loader [reportType]="chartView.overView" [loaderSize]="1"  [height]="'150px'"></app-skeleton-loader>
    </ng-container>
    <div class="property-details" *ngIf="landInformation">

        <div class="property-info">
            <h4>{{ propertyInfo?.neigh_name | langtranslate}}</h4>
            <!-- <p>{{ propertyDetail?.address }}</p> -->

            <div class="property-zone" *ngIf="areaInformation?.zoning">
                <h4>{{'reports.property_type_zoning' | translate}}</h4>
                <div class="zoning-info">
                    <span>{{ "reports.zoning" | translate }} : <strong>{{ areaInformation?.zoning }}</strong></span>
                </div>

            </div>

            <div class="property-information">
                <h4>{{'reports.neighborhoodInformation' | translate}}</h4>

                <div class="property-details-d">
                    <div class="property-area">
                        <h6>{{'reports.total_area' | translate}}</h6>
                        <span [matTooltip]="areaInformation?.total_land_area">{{ areaInformation?.total_land_area ?
                            areaInformation?.total_land_area : ('na' | translate)
                            }}</span>
                        <h6 *ngIf="areaInformation?.total_land_area">{{sqm_unit | translate}}</h6>
                    </div>
                    <div class="property-area frontage">
                        <h6>{{'Roads' | translate}}</h6>
                        <span [matTooltip]="areaInformation?.road">{{ areaInformation?.road ?
                            areaInformation?.road+'%' : ('na' | translate) }}</span>
                    </div>
                    <div class="property-area setback">
                        <h6>{{'reports.parks' | translate}}</h6>
                        <span [matTooltip]="areaInformation?.park">{{ areaInformation?.park ?
                            areaInformation?.park+'%' : ('na' | translate) }}</span>
                        <h6 *ngIf="areaInformation?.park"></h6>
                    </div>
                    <div class="property-area corner">
                        <h6>{{'reports.plots' | translate}}</h6>
                        <span [matTooltip]="areaInformation?.plot">{{ areaInformation?.plot ? areaInformation?.plot+'%' :
                            ('na' | translate) }}</span>

                    </div>
                </div>
            </div>
        </div>

        <div class="property-info-img">
            <div class="property-imgD">
                <img src="assets/images/housevilla.png">
            </div>

        </div>

    </div>
    <ng-container *ngIf="allDataLoading">
        <app-skeleton-loader [reportType]="chartView.overView" [loaderSize]="3" [height]="'150px'"></app-skeleton-loader>
    </ng-container>
    <div class="report-overview report-overview-3col reportov-housevilla" *ngIf="landInformation">
        <app-overview-card
                [card_title]="'reports.totalLandVillas'" 
                [total_current]="landInformation?.total_land"
                [untillDate]="landInformation?.max_date"
                [total_prev]="landInformation?.prev_total_land"
                [total_percentage]="landInformation?.tot_land_diff"></app-overview-card>

        <app-overview-card
                [card_title]="'reports.averageLandArea'" 
                [total_current]="landInformation?.avg_land"
                [untillDate]="landInformation?.max_date"
                [total_prev]="landInformation?.prev_avg_land"
                [total_percentage]="landInformation?.avg_land_diff"
                [uniType]="UnitTypeEnum.sqm"></app-overview-card>
            
        <app-overview-card
                [card_title]="'reports.landDevelopmentRate'" 
                [total_current]="landInformation?.land_dev_rate"
                [untillDate]="landInformation?.max_date"
                [total_prev]="landInformation?.prev_land_dev_rate"
                [total_percentage]="landInformation?.land_dev_rate_diff"
                [uniType]="UnitTypeEnum.percentage"></app-overview-card>
        
    </div>
    <div class="report-chart-overview">
        <div class="overview overview-chart">
            <div class="overview-data">
                <h2>{{"reports.developed_vs_vacant_villas" | translate}}</h2> 
            </div>
           
            <ng-container *ngIf="allDataLoading">
                <app-skeleton-loader [reportType]="chartView.pieChart"></app-skeleton-loader>
            </ng-container>
            <ng-container *ngIf="landInformationPieData.length; else noDataMessage">
                <app-report-chart-view
                [height]="'200px'"
                [data]="landInformationPieData"
                [chartType]="chartView.pieChart"
                [isBorder]="false"
                ></app-report-chart-view>
            </ng-container>
            <ng-template #noDataMessage>
                <div class="data_unavail">
                    <span>
                        {{"reports.data_not_available" | translate}} <mat-icon  role="img" class="mat-icon notranslate material-icons mat-ligature-font mat-icon-no-color" aria-hidden="true" data-mat-icon-type="font">equalizer</mat-icon>
                    </span>
                </div>
            </ng-template>
            <!-- <ng-container *ngIf="landInformationPieData.length == 0">
                <p>{{"reports.no_record_found" | translate}}</p>
            </ng-container> -->
        </div>
    </div>
</div>
